export const BorrowerSelectorTestIds = {
  BORROWER_SELECT: 'borrower-selector.borrower-select',
};
